export const ERRORS = {
  NewPasswordRequired: 'NewPasswordRequired',
  PasswordAlreadySet: 'PasswordAlreadySet',
  AttributesRequired: 'AttributesRequired',
  NotAuthorizedException: 'NotAuthorizedException',
  InvalidParameterException: 'InvalidParameterException',
  MFARequired: 'MFARequired',
  InvalidPasswordException: 'InvalidPasswordException',
  UserNotFoundException: 'UserNotFoundException',
  UsernameExistsException: 'UsernameExistsException'
};



// WEBPACK FOOTER //
// ./src/cognito-redux/constants.js